import { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { IUsuarios } from "../../interfaces/IUsuarios";
import UsuariosService from "../../services/UsuariosService";
import Swal from 'sweetalert2';
import UsuariosModal from "./UsuariosModal";
import UsuariosTabela from "./UsuariosTabela";
import { useAuth } from "../../contexts/AuthProvider";

function Usuarios() {

    const intl = useIntl();
    const {usuario: usuarioLogado} = useAuth();
    const { classes } = useLayout();
    const [usuarios, setUsuarios] = useState<IUsuarios[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [usuario, setUsuario] = useState<IUsuarios>({} as IUsuarios);
    const [modalTitle, setModalTitle] = useState<string>('');
    const [paginaCarregada, setPaginaCarregada] = useState<boolean>(false);
    const columns = [
        {
            name: 'Nome',
            selector: (row: IUsuarios) => row['nome'],
            sortable: true,
            wrap: true
        },
        {
            name: 'Email',
            selector: (row: IUsuarios) => row['email'],
            sortable: true,
            wrap: true
        },
        {
            name: 'Nome de Usuário',
            selector: (row: IUsuarios) => row['nomeUsuario'],
            sortable: true,
            wrap: true
        },
        {
            name: 'Perfil',
            selector: (row: IUsuarios) => row['perfil'],
            sortable: true,
            wrap: true
        },
        {
            name: 'Ações',
            cell: (row: IUsuarios) => <AcoesUsuarios bloquearUsuario={bloquearUsuario} excluirUsuario={excluirUsuario} editarUsuario={(usuario: IUsuarios) => {
                setModalTitle('Editar Usuário');
                setUsuario(usuario);
                toggleModal();
            }} item={row} />,
            wrap: true
        }
    ];

    useEffect(() => {
        const content = document.getElementById('kt_content_container')
        const estilo = (content?.getAttribute('style') ?? "") + 'padding: 10px';

        content?.setAttribute('style', estilo);
        
        setTimeout(() => {
            carregarUsuarios();
        }, 100)
    }, []);

    async function carregarUsuarios() {
        if(usuarioLogado?.clienteID){
            setPaginaCarregada(false);
            await UsuariosService.obterTodosPorClienteID(usuarioLogado.clienteID, x => setUsuarios(x));
            setPaginaCarregada(true);
        }
    }

    function toggleModal(loadItens?: boolean): void {
        if (loadItens) {
            carregarUsuarios();
        }

        setShowModal(!showModal);

        if (showModal) {
            setTimeout(() => {
                setUsuario({} as IUsuarios)
            }, 300)
        }
    }

    async function bloquearUsuario(usuario: IUsuarios) {
        const titulo = `${ usuario.bloqueado ? 'Desbloquear' : 'Bloquear' } Usuário`;
        const pergunta = `Você realmente deseja ${ usuario.bloqueado ? 'desbloquear' : 'bloquear' } esse Usuário?`;
        const textoSucesso = `Usuário ${ usuario.bloqueado ? 'desbloqueado' : 'bloqueado'} com sucesso`;
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-modal-excluir ms-5',
                cancelButton: 'btn btn-modal-cancelar'
            },
            buttonsStyling: false
        });
        const result = await swalWithBootstrapButtons.fire({
            title: titulo,
            text: pergunta,
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: `${ usuario.bloqueado ? 'Desbloquear' : 'Bloquear' }`,
            reverseButtons: true
        });

        if (result.isConfirmed) {
            if (usuario.bloqueado) {
                await UsuariosService.desbloquear(usuario.id, async () => await carregarUsuarios(), textoSucesso);
            }
            else {
                await UsuariosService.bloquear(usuario.id, async () => await carregarUsuarios(), textoSucesso);
            }
        }
    }

    async function excluirUsuario(evento: IUsuarios) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-modal-excluir ms-5',
                cancelButton: 'btn btn-modal-cancelar'
            },
            buttonsStyling: false
        });
        const result = await swalWithBootstrapButtons.fire({
            title: 'Excluir Usuário',
            text: `Você realmente deseja excluir esse Usuário?`,
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: `Excluir`,
            reverseButtons: true
        });

        if (result.isConfirmed) {
            await UsuariosService.excluir(evento.id, () => setUsuarios(usuarios.filter(e => e.id !== evento.id)), 'Usuário excluído com sucesso');
        }
    }

    function AcoesUsuarios({ item, excluirUsuario, editarUsuario, bloquearUsuario }: { item: IUsuarios, excluirUsuario: (usuario: IUsuarios) => void, editarUsuario: (Usuario: IUsuarios) => void, bloquearUsuario: (Usuario: IUsuarios) => void }) {
        return <div data-tag="allowRowEvents">
            <i onClick={() => bloquearUsuario(item)}className={item.bloqueado?"bi bi-unlock fs-1":"bi bi-lock fs-1"} style={{ color: '#5E6397', WebkitTextStrokeWidth: '0.7px', marginRight: '20px', cursor: 'pointer' }}/>
            <i onClick={() => editarUsuario(item)} className="fas fa-edit fs-1" style={{ color: '#5E6397', fontWeight: 'normal', cursor: 'pointer' }}/>
            <i onClick={() => excluirUsuario(item)} className="fas fa-trash-alt fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }}/>
        </div>
    }

    return <>
        <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.USERS' })}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
                <UsuariosModal usuario={usuario} title={modalTitle} show={showModal} toggleModal={toggleModal} />
                <div className='d-flex align-items-center py-1'>
                    <button onClick={() => {
                        setModalTitle('Cadastrar Usuário');
                        setUsuario({id: 0} as IUsuarios);
                        setShowModal(true);
                    }} className='btn btn-sm btn-primario'>
                        <i className="icon-lg text-white fas fa-plus"></i>
                        <span style={{ verticalAlign: 'middle' }}> USUÁRIO </span>
                    </button>
                </div>
            </div>
        </div>
        
        {
            paginaCarregada ? <UsuariosTabela colunas={columns} itens={usuarios} /> : <p>Carregando...</p>
        }
    </>
};

export default Usuarios;